module.exports = __webpack_public_path__ + "static/media/vip_cover_bg.107d0680.png";